import * as React from 'react'
import Header from './Base'
import { Router } from 'routes'
import NextRouter from 'next/router'
import { Icon, Fab, IconButton } from '@material-ui/core'
import * as Auth from 'models/Auth'
import { Menu } from 'components'
import styled from 'styled-components'
import WebpImg from 'components/Image/WebpImg'

const Mini = ({
  client,
  back = false,
  renderLeft = null,
  standalone = false,
}) => {
  return (
    <Header>
      <Left>
        {back && (
          <IconButton size="small" onClick={() => NextRouter.back()}>
            <Icon>arrow_back</Icon>
          </IconButton>
        )}
        {renderLeft}
      </Left>
      {!standalone && (
        <Right>
          <IconButton
            onClick={() => {
              if (window.Intercom) window.Intercom('show')
            }}
          >
            <Icon>help_outline</Icon>
          </IconButton>
          <Fab
            style={{ marginRight: 12, backgroundColor: '#D8D8D8' }}
            onClick={() => Router.pushRoute('root')}
            size="small"
          >
            <LogoWebpImg
              webpSrc="/static/images/logo_icon.webp"
              imgSrc="/static/images/logo_icon.png"
              imgProps={{ alt: 'logo' }}
            />
          </Fab>
          <div style={{ display: 'inline-flex', marginRight: 10 }}>
            <Menu.Avatar
              onLogout={async () => {
                await Auth.signout()
                client.resetStore()
                // トップに戻す
                NextRouter.push('/')
              }}
            />
          </div>
        </Right>
      )}
    </Header>
  )
}

export default Mini

const Left = styled.div`
  flex: 1 1 auto;
`

const Right = styled.div`
  display: flex;
  align-items: center;
`

const LogoWebpImg = styled(WebpImg)`
  width: 30px;
  vertical-align: middle;
`
